<template>
    <HomeLayoutBack customClass="max-w-1140px">
        <BackButtonDesktop @clickBack="clickBack()"></BackButtonDesktop>
        <div class="border-b border-a-brown-e1d2bc" v-if="campaign != null">
            <div class="grid grid-cols-1 lg:grid-cols-10 gap-4 lg:gap-8 mt-6" >
                <div class="lg:col-span-6 px-4 lg:px-0">
                    <img class="w-full rounded-20" :src="campaign.imageUrl">
                    <div class="block lg:hidden text-16 font-bold text-a-brown-502314 mt-3">{{campaign.name}}</div>
                    
                </div>
                <div class="box-detail lg:col-span-4 border-0 lg:border border-a-brown-d7c7b8 rounded-20 p-0 lg:p-6 relative">
                    <DetailAndCondition :campaign="campaign"></DetailAndCondition>
                    <div class="flex py-4 border-t border-a-brown-d7c7b8 px-4"
                        v-if="campaign.details.length > 0">
                        <div class="text-a-brown-502314 package-left">{{ lbl.subscription.buy.subscription_package }}</div>
                        <div class="cursor-pointer ml-auto mr-0 package-right relative" @click="onClickSubscription()">
                            <div class="text-a-red-d62300 text-right text-1-line">
                                {{ subScriptPackage && subScriptPackage.SubscriptionDetailName ? subScriptPackage.SubscriptionDetailName : 'See more subscription' }}
                            </div>
                            <img class="absolute bottom-1 right-0 ml-1 mr-0" src="@/assets/icon/ic-arrow-right-brown.svg" />
                        </div>
                    </div>
                    <div class="hidden lg:block w-full absolute bottom-0 left-0 p-6">
                        <!-- <div class="text-center text-16 text-a-brown-502314">
                            {{FilterNumberFormat(campaign.Discount)}} {{ lbl.campaign.baht }}
                        </div> -->
                        <div v-if="isLoginGuest" class="text-12 text-a-red-d14545 text-center mt-3">{{lbl.detail.warnning_guest_1}} <span class="underline cursor-pointer" @click="clickLogin()">{{lbl.detail.warnning_guest_2}}</span></div>
                        <div class="max-w-xs m-auto">
                            <RedButton @click="clickRedeem()">
                                <div>Redeem</div>
                            </RedButton>
                        </div>
                    </div>
                </div>
            </div>
            <div class="hidden lg:block text-24 font-bold text-a-brown-502314 mt-6">{{campaign.name}}</div>
        </div>
        <div class="block lg:hidden" v-if="campaign != null">
            <div class="dummy-footer"></div>
            <div class="fixed w-full left-0 bottom-0 footer-shadow bg-a-egg-f5ebdc py-3 px-4">
                <!-- <div class="text-center text-14 text-a-brown-502314">
                    {{FilterNumberFormat(campaign.Discount)}} {{ lbl.campaign.baht }}
                </div> -->
                <div v-if="isLoginGuest" class="text-12 text-a-red-d14545 text-center mt-3">{{lbl.detail.warnning_guest_1}} <span class="underline cursor-pointer" @click="clickLogin()">{{lbl.detail.warnning_guest_2}}</span></div>
                <div class="mt-3 px-2">
                    <RedButton @click="clickRedeem()">
                        <div>{{ lbl.subscription.subscription_detail.btn }}</div>
                    </RedButton>
                </div>
            </div>
        </div>
    </HomeLayoutBack>
</template>
<script>

//helper
import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager.js';
import CacheHelper from '@/helper/CacheHelper.js';
//component
import HomeLayoutBack from '@/components/Layout/Page/HomeLayoutBack.vue'
import BackButtonDesktop from '@/components/Button/BackButtonDesktop.vue'

import DetailAndCondition from '../component/DetailAndCondition.vue';
// import RedeemButton from '../component/RedeemButton.vue';
import RedButton from '@/components/Button/RedButton.vue'
// import DisableBtn from '@/components/Button/DisableBtn.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
//controller
import { DetailController } from '../controller/DetailController.js';
import { RedeemController } from '../controller/RedeemController.js';
//service
// import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import { CampaignType } from "@/helper/StaticValue.js";
import BKSubscription from '@/module/Subscription/List/service/BKSubscription';
import campaigeModel from "../model/CampaignModel"
import { SerialModel } from "@/core/Redeem/model/SerialModel"

export default {
    inject: ['SideMenuStore'],
    mixins: [ModalMixin, AuthStatusMixin, LocaleMixin],
    components: {
        HomeLayoutBack,
        BackButtonDesktop,
        DetailAndCondition,
        // RedeemButton,

        RedButton,
        // DisableBtn,
    },
    data: function() {
        return {
            isLoaded: false,
            //controller
            detailController: new DetailController(),
            redeemController: new RedeemController(),

            campaign: null,
            campaignRelate: [],
            isNotiDetail: false,
            isPackage: false,
            subScriptPackage: null,
            isLoadedPackage: false,

        };
    },
    mounted: function () {
        Util.scrollTop();

    },
    methods: {
        //#region mixin
        /**
         * ฟังก์ชันนี้ถูกเรียก หลังจากตรวจสอบได้แล้วว่า login แล้วหรือยัง
         */
        onAccountInit: async function () {
            this.initialCampaign();
        },
        /**
         * ฟังก์ชันนี้ถูกเรียก หลักจาก setup generic model เรียบร้อย
         */
        onSetupModalCompleted: function() {
            this.initialRedeemModal(); //ModalMixin
            this.initialAddressModal(); //ModalMixin
        },
        //#endregion mixin

        //#region initial
        initialCampaign: function () {
            let campaignId = this.$route.params.campaignId;
            let detailKey = this.$route.params.detailkey;
            this.getDetail(campaignId,detailKey);
        },

        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        initialIsFromLanding: function () {
            var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            var formLanding = Util.jsonParse(cacheHelper.getCache('isfromlanding'));

            if (formLanding != null) {
                cacheHelper.removeCache('isfromlanding');

                if (formLanding.page == 'wodd') {
                    return;
                }
                var backAmount = (formLanding.page == 'interface') ? -3 : -2;
                history.go(backAmount);
            }
        },
        //#endregion initial

        //#region setup
        getDetail: function (campaignId,detailKey) {
            this.modal.loadingModal.show();
            BKSubscription.apiGetSubscriptionDetail(campaignId,detailKey).subscribe({
                next: (res) => {
                    this.campaign = new campaigeModel(res)
                    // console.log(this.campaign)
                    this.subScriptPackage = this.campaign.details.find(x => x.Selected);
                    // console.log(this.subScriptPackage)
                    this.modal.loadingModal.hide();
                },
                error: (err) => {
                    this.modal.loadingModal.hide();
                    this.errorApi(err);
                }
            });
        },
        //#endregion setup
        //#region event
        clickRedeem: function() {
            this.modal.confirmRedeemSubscriptionModal
                            .clearModal()
                            .setCampaign(this.campaign)
                            .show()
                            
            this.modal.confirmRedeemSubscriptionModal.onClickOk(() => {
                this.redeem();
            })
        },
        
        //#endregion event

        onLoadedCampaign: async function () {
            if (this.isTypeBuy()) {
                this.isLoadedPackage = true;
            } else {
                this.isLoadedPackage = true;
            }
        },

        isTypeBuy: function () {
            return this.campaign.type == CampaignType.Buy;
        },

        clickLogin: function () {
            let path = this.$route.path;
            this.$router.push('/login?afterLogin=' + path);
        },
        clickBack: function () {
            this.$router.back();
        },

        onClickSubscription: function () {
            // // create subscription temp for manage subscription
            let subscriptionTemp = this.campaign.details.map((item) => {
                return {
                    ...item
                }
            })
            this.SideMenuStore.methods.openSubscription(subscriptionTemp, null, 'offline', (data) => {
                // console.log('openSubscription',data);
                this.subScriptPackage = data.find(x => x.Selected);
                // console.log(this.subScriptPackage);
            })
        },

        redeem : function () {
            // if (!this.subScriptPackage.CampaignId) return;
            this.modal.loadingModal.show();
            BKSubscription.apiRedeenSubscription(this.subScriptPackage.CampaignId, this.campaign.detailKey).subscribe({
                next: (res) => {
                    // console.log(res)
                    this.campaign.updateAfterRedeem(res.data)
                    this.initialSerial(this.campaign)
                    this.modal.loadingModal.hide();
                },
                error: (err) => {
                    this.errorApi(err);
                    this.modal.loadingModal.hide();
                }
            });
        },
        
        initialSerial: function (campaign) {
            let serial = new SerialModel();
            serial.setModelFromDataModel(campaign);
            this.modal.serialModal
                .setSerial(serial)
                .show();   
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .box-detail {
        @include md-screen() {
            padding-bottom: 117px;
        }
    }

    .package-left {
        width: 165px;
    }

    .package-right {
        width: calc(100% - 165px);
        padding-right: 15px;
    }
</style>
